import {
  FETCHING_INTERACTIVE_PAGES_REPORTS, FETCHING_INTERACTIVE_PAGES_REPORTS_SUCCEEDED, FETCHING_INTERACTIVE_PAGES_REPORTS_FAILED,
  FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS, FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS_SUCCEEDED, FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS_FAILED,
  FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES, FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES_SUCCEEDED, FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES_FAILED,
  FETCHING_INTERACTIVE_DOWNLOADS_TRENDS, FETCHING_INTERACTIVE_DOWNLOADS_TRENDS_SUCCEEDED, FETCHING_INTERACTIVE_DOWNLOADS_TRENDS_FAILED,
  FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE, FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE_SUCCEEDED, FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE_FAILED
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;

const INTERACTIVE_REPORTS_BASE_URL = `${apiUrl}/api/1.0/interactive/reports`;

/**
 * Fetch Interactive Page Reports
*/
export const fetchInteractivePagesReports = createAction(FETCHING_INTERACTIVE_PAGES_REPORTS, (request, page, limit) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingInteractivePagesReportsSucceeded = createAction(FETCHING_INTERACTIVE_PAGES_REPORTS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingInteractivePagesReportsFailed = createAction(FETCHING_INTERACTIVE_PAGES_REPORTS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingInteractivePagesReportsSaga(action) {
  const { request, page, limit } = action.payload;

  let url = buildUrl(INTERACTIVE_REPORTS_BASE_URL, {
    path: `/pages?page=${page}&limit=${limit}`
  });

  const fetchingInteractivePagesReportsAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingInteractivePagesReportsAPI);
    if (response) {
      yield put(fetchingInteractivePagesReportsSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingInteractivePagesReportsFailed(request.storyboard, error));
  }
}

/**
 * Fetch Interactive Page Reports For charts
*/
export const fetchInteractivePagesChartReports = createAction(FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS, (request, page, limit) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingInteractivePagesChartReportsSucceeded = createAction(FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingInteractivePagesChartReportsFailed = createAction(FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingInteractivePagesChartsSaga(action) {
  const { request, page, limit } = action.payload;

  let url = buildUrl(INTERACTIVE_REPORTS_BASE_URL, {
    path: `/pages?page=${page}&limit=${limit}`
  });

  const fetchingInteractivePagesReportsAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingInteractivePagesReportsAPI);
    if (response) {
      yield put(fetchingInteractivePagesChartReportsSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingInteractivePagesChartReportsFailed(request.storyboard, error));
  }
}

/**
 * Fetch Interactive page downloads time series
*/
export const fetchInteractiveDownloadsTimeSeries = createAction(FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES, (request) => {
  return {
    request: request
  }
});

const fetchingInteractivePageDownloadsTimeSeriesSucceeded = createAction(FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingInteractivePageDownloadsTimeSeriesFailed = createAction(FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* fetchingInteractivePageDownloadsTimeSeriesSaga(action) {
  const { request } = action.payload;

  let url = buildUrl(INTERACTIVE_REPORTS_BASE_URL, {
    path: `/downloads/graph`
  });

  const fetchingInteractivePageDownloadsTimeSeriesAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingInteractivePageDownloadsTimeSeriesAPI);
    if (response) {
      yield put(fetchingInteractivePageDownloadsTimeSeriesSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingInteractivePageDownloadsTimeSeriesFailed(request.storyboard, error));
  }
}

/**
 * Fetch Interactive page downloads trends
*/
export const fetchInteractivePageDownloadsTrends = createAction(FETCHING_INTERACTIVE_DOWNLOADS_TRENDS, (request) => {
  return {
    request: request
  }
})

const fetchingInteractivePageDownloadsTrendsSucceeded = createAction(FETCHING_INTERACTIVE_DOWNLOADS_TRENDS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const fetchingInteractivePageDownloadsTrendsFailed = createAction(FETCHING_INTERACTIVE_DOWNLOADS_TRENDS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingInteractivePageDownloadsTrendsSaga(action) {
  const { request } = action.payload;

  let url = buildUrl(INTERACTIVE_REPORTS_BASE_URL, {
    path: `/downloads/graph`
  });

  const fetchingInteractivePageDownloadsTrendsAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingInteractivePageDownloadsTrendsAPI);
    if (response) {
      yield put(fetchingInteractivePageDownloadsTrendsSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingInteractivePageDownloadsTrendsFailed(request.storyboard, error));
  }
}


/**
 * Fetch Page Bar Analytics Chart For Interactive
*/
export const fetchAnalyticsChartForInteractive = createAction(FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE, (request, type) => {
  return {
    request: request,
    type: type
  }
});

const fetchAnalyticsChartForInteractiveSucceeded = createAction(FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE_SUCCEEDED, (id, response, type) => {
  return {
    id: id,
    response: response,
    type: type
  }
});

const fetchAnalyticsChartForInteractiveFailed = createAction(FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE_FAILED, (id, error, type) => {
  return {
    id: id,
    error: error,
    type: type
  }
})

function* fetchAnalyticsReportsForIneractiveSaga(action) {
  const { request, type } = action.payload;

  let url = buildUrl(INTERACTIVE_REPORTS_BASE_URL, {
    path: `/analytics`
  });

  const fetchAnalyticsChartForInteractiveAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    var response = yield call(fetchAnalyticsChartForInteractiveAPI);

    if (response) {
      yield put(fetchAnalyticsChartForInteractiveSucceeded(request.storyboard, response, type));
    }
  } catch (error) {
    yield put(fetchAnalyticsChartForInteractiveFailed(request.storyboard, error, type));
  }
}

export default function* interactiveReportSaga() {
  yield takeEvery(FETCHING_ANALYTICS_CHART_FOR_INTERACTIVE, fetchAnalyticsReportsForIneractiveSaga);
  yield takeEvery(FETCHING_INTERACTIVE_PAGES_REPORTS, fetchingInteractivePagesReportsSaga);
  yield takeEvery(FETCHING_INTERACTIVE_PAGES_CHARTS_REPORTS, fetchingInteractivePagesChartsSaga);
  yield takeEvery(FETCHING_INTERACTIVE_DOWNLOADS_TIME_SERIES, fetchingInteractivePageDownloadsTimeSeriesSaga);
  yield takeEvery(FETCHING_INTERACTIVE_DOWNLOADS_TRENDS, fetchingInteractivePageDownloadsTrendsSaga);
}